import React from 'react';
import { PageTitle } from '../../../shared/components/ui/PageTitle';
import { InfoBanner } from '../../../shared/components/ui/InfoBanner';

const CustomerProofread: React.FC = () => {
  return (
    <div>
      <PageTitle subtitle="Document proofreading and review services">Proofread</PageTitle>
      <InfoBanner>Proofreading service coming soon. Check back later for document review capabilities.</InfoBanner>
    </div>
  );
};

export default CustomerProofread;
